import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import FieldTip from '../ui/FieldTip';

const ETF_TYPES = [
  'Equity',
  'Bonds',
  'Sector',
  'Commodity'
];

const ETFFields = ({ formData, onFieldChange }) => {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="etf_type" className="portfolio-input-label">ETF Type<FieldTip field="etf_type" /></Label>
        <Select 
          value={formData.etf_type} 
          onValueChange={(value) => onFieldChange('etf_type', value)}
        >
          <SelectTrigger className="portfolio-input">
            <SelectValue placeholder="Select ETF type" />
          </SelectTrigger>
          <SelectContent>
            {ETF_TYPES.map((etfType) => (
              <SelectItem key={etfType} value={etfType}>{etfType}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="etf_isin" className="portfolio-input-label">ISIN No.</Label>
        <Input
          id="etf_isin"
          placeholder="e.g. US1234567890"
          value={formData.etf_isin}
          onChange={(e) => onFieldChange('etf_isin', e.target.value)}
          className="portfolio-input"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="etf_index_tracked" className="portfolio-input-label">Index Tracked<FieldTip field="index_tracked" /></Label>
        <Input
          id="etf_index_tracked"
          placeholder="e.g. S&P 500, FTSE 100"
          value={formData.etf_index_tracked}
          onChange={(e) => onFieldChange('etf_index_tracked', e.target.value)}
          className="portfolio-input"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="etf_units" className="portfolio-input-label">No. of Units/Shares</Label>
        <Input
          id="etf_units"
          type="number"
          step="0.01"
          placeholder="0"
          value={formData.etf_units}
          onChange={(e) => onFieldChange('etf_units', e.target.value)}
          className="portfolio-input"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="etf_purchase_price_per_unit" className="portfolio-input-label">Purchase Price per Unit</Label>
        <Input
          id="etf_purchase_price_per_unit"
          type="number"
          step="0.01"
          placeholder="0.00"
          value={formData.etf_purchase_price_per_unit}
          onChange={(e) => onFieldChange('etf_purchase_price_per_unit', e.target.value)}
          className="portfolio-input"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="etf_current_nav" className="portfolio-input-label">Current NAV<FieldTip field="current_nav" /></Label>
        <Input
          id="etf_current_nav"
          type="number"
          step="0.01"
          placeholder="0.00"
          value={formData.etf_current_nav}
          onChange={(e) => onFieldChange('etf_current_nav', e.target.value)}
          className="portfolio-input"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="etf_fund_manager" className="portfolio-input-label">Fund Manager</Label>
        <Input
          id="etf_fund_manager"
          placeholder="e.g. BlackRock, Vanguard"
          value={formData.etf_fund_manager}
          onChange={(e) => onFieldChange('etf_fund_manager', e.target.value)}
          className="portfolio-input"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="etf_fund_sponsor" className="portfolio-input-label">Fund Sponsor<FieldTip field="fund_sponsor" /></Label>
        <Input
          id="etf_fund_sponsor"
          placeholder="Sponsoring organization"
          value={formData.etf_fund_sponsor}
          onChange={(e) => onFieldChange('etf_fund_sponsor', e.target.value)}
          className="portfolio-input"
        />
      </div>
    </>
  );
};

export default ETFFields;
